import { resourceHints } from '@yonderland/andes-react';
export default () => resourceHints;
